import React, { useEffect, useState } from 'react';
import ModalBase from 'components/Tvendo/Common/ModalBase';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { wsGetAll } from 'services/WService';
import Table from 'components/Table/Table';
import moment from 'moment';

const GroupNums = [
  { GroupNum: '-1', PymntGroup: 'Contado' },
  { GroupNum: '1', PymntGroup: 'CREDITO 30 DIAS' },
  { GroupNum: '2', PymntGroup: 'CREDITO 60 DIAS' },
  { GroupNum: '3', PymntGroup: '90 Días sin Intereses' },
  { GroupNum: '4', PymntGroup: 'Cuotas 30, 60, 90 s/Intereses' },
  { GroupNum: '5', PymntGroup: 'CREDITO 7 DIAS' },
  { GroupNum: '6', PymntGroup: 'CREDITO 15 DIAS' },
  { GroupNum: '7', PymntGroup: 'CREDITO 20 DIAS' },
  { GroupNum: '8', PymntGroup: 'CREDITO 45 DIAS' },
  { GroupNum: '9', PymntGroup: 'LETRA 30 DIAS' },
  { GroupNum: '10', PymntGroup: 'LETRA 45 DIAS' },
  { GroupNum: '11', PymntGroup: 'LETRA 60 DIAS' },
  { GroupNum: '12', PymntGroup: 'LETRA 75 DIAS' },
  { GroupNum: '13', PymntGroup: 'CHEQUE 7 DIAS' },
  { GroupNum: '14', PymntGroup: 'CHEQUE 15 DIAS' },
  { GroupNum: '15', PymntGroup: 'CHEQUE 30 DIAS' },
  { GroupNum: '16', PymntGroup: 'CREDITO 3 DIAS' },
  { GroupNum: '17', PymntGroup: 'CHEQUE 20 DIAS' },
  { GroupNum: '18', PymntGroup: 'CREDITO 8 DIAS' },
];

function PendientOrdersModal(props) {
  const { model, setOpen } = props;
  const [pendientOrders, setPendientOrders] = useState([]);

  async function getPendientOrders() {
    let res = await wsGetAll(`sap/business-partner/receivable?CardCode=${model.CardCode}`);
    if (res.success) {
      setPendientOrders(res.data);
    } else {
      window.alert(res.message);
    }
  }

  useEffect(() => {
    if (model.CardCode === undefined) {
      setPendientOrders([]);
      return;
    }
    getPendientOrders();
  }, [model]);

  return (
    <ModalBase
      title={`Pendientes de pago`}
      model={model}
      setOpen={setOpen}
      hideSave
      fullWidth
      maxWidth="lg"
    >
      <GridContainer>
        {!!model?.CardCode && (
          <GridItem xs={12}>
            <h6>Cliente</h6>
            <h5>
              ({model.CardCode}) {model.CardName}
            </h5>
          </GridItem>
        )}
        <GridItem xs={12}>
          <Table
            tableHead={[
              '#',
              'Documento',
              'HR',
              'Fecha Documento',
              'Fecha Vencimiento',
              'Vendedor',
              'Término Pago',
              'Monto',
              'Pagado',
              'Pendiente',
            ]}
            tableData={pendientOrders.map((item, index) => {
              return [
                index + 1,
                `${item.U_SYP_MDSD}-${item.U_SYP_MDCD}`,
                `${item.ImportEnt}`,
                moment(item.TaxDate).format('DD-MM-YYYY'),
                moment(item.DocDueDate).format('DD-MM-YYYY'),
                item.SlpName,
                GroupNums.find((gn) => gn.GroupNum === item.GroupNum)?.PymntGroup || item.GroupNum,
                parseFloat(item.DocTotal).toFixed(2),
                parseFloat(item.PaidToDate).toFixed(2),
                (parseFloat(item.DocTotal) - parseFloat(item.PaidToDate)).toFixed(2),
              ];
            })}
          />
        </GridItem>
      </GridContainer>
    </ModalBase>
  );
}

export default PendientOrdersModal;
